module.exports = __webpack_public_path__ + "media/images/redesign-images/higher-ed/event-04-2993aef3d929f8a93a65ef5f1cf7d155.jpg";